import t from"react";const e=t.createContext({isHidden:!0});export{e as TooltipContext};
//# sourceMappingURL=TooltipProvider.js.map
